import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers/RootReducer";
import { airStaffApi } from "../features/catalogues/lib/airStaff/airStaffApi";
import { airBaseApi } from "../features/catalogues/lib/airBase/airBaseApi";
import { airTransportApi } from "../features/catalogues/lib/airTransport/airTransportApi";
import { contractorsApi } from "../features/catalogues/lib/contractors/contractorsApi";
import { contractApi } from "../features/catalogues/lib/contracts/contractApi";
import { flightApi } from "../features/catalogues/lib/flight/flightApi";
import { workTypesApi } from "../features/catalogues/lib/workTypes/workTypesApi";
import { contracWorkstApi } from "../features/catalogues/lib/contractWorks/contractWorksApi";
import { contractAircraftsApi } from "../features/catalogues/lib/contractAircrafts/contractAircraftApi";
import { transportApi } from "../api/transportApi";
import { workCostApi } from "../features/catalogues/lib/workCost/workCostApi";
import { worksCompletedApi } from "../features/catalogues/lib/worksCompleted/worksCompletedApi";
import { pilotsApi } from "../features/catalogues/lib/pilots/pilotsApi";
import { reviewApi } from "../features/catalogues/lib/review/reviewApi";
import { landCategoryApi } from "../api/landCategoriesApi";
import { routesApi } from "../api/routesApi";

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      airStaffApi.middleware,
      airBaseApi.middleware,
      airTransportApi.middleware,
      contractorsApi.middleware,
      contractApi.middleware,
      flightApi.middleware,
      contracWorkstApi.middleware,
      contractAircraftsApi.middleware,
      transportApi.middleware,
      workTypesApi.middleware,
      workCostApi.middleware,
      worksCompletedApi.middleware,
      pilotsApi.middleware,
      reviewApi.middleware,
      landCategoryApi.middleware,
      routesApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
